module.exports = __webpack_public_path__ + "img/couples-041.daa060a7.jpg";